import React from 'react';

import { CartCouponAffectedProducts } from '../../coupon-apply';
import { CartSummaryTotal, type SummaryTotalsViewModel } from './CartSummaryTotal';
import { MobileSummaryDetails } from '../styles';

export type SummaryDetailsViewModel = SummaryTotalsViewModel & {
  hasDetails: boolean;
  showAffectedProducts: boolean;
  affectedProductNames: string[];
};

type SummaryDetailsProps = Omit<React.ComponentPropsWithoutRef<'div'>, 'children'> & {
  summary: SummaryDetailsViewModel;
  canManageCoupon?: boolean;
  affectedProductsMaxVisible?: number;
};

export const SummaryDetails = (props: SummaryDetailsProps) => {
  const { summary, canManageCoupon = false, affectedProductsMaxVisible = 5, ...rest } = props;

  if (!summary.hasDetails && !summary.showAffectedProducts) {
    return null;
  }

  return (
    <MobileSummaryDetails {...rest}>
      <CartSummaryTotal
        summary={{
          ...summary,
          showSubtotal: false,
          showTotal: false,
          canManageCoupon,
        }}
      />

      {summary.showAffectedProducts ? (
        <CartCouponAffectedProducts
          productNames={summary.affectedProductNames}
          maxVisible={affectedProductsMaxVisible}
        />
      ) : null}
    </MobileSummaryDetails>
  );
};

export default SummaryDetails;
